// Draws the signing screen (agreement + payout + "sign here" line) at any size, so the
// on-screen box and the Wacom pad show the same layout and pen positions line up.
function wrap(g, text, maxW) {
  const lines = []; let cur = "";
  text.split(/\s+/).forEach((w) => {
    const t = cur ? `${cur} ${w}` : w;
    if (g.measureText(t).width <= maxW || !cur) cur = t; else { lines.push(cur); cur = w; }
  });
  if (cur) lines.push(cur);
  return lines;
}

export const SIGN_LINE_Y = 0.8;

export function paintSigningScreen(g, w, h, { heading, amountLabel, amount, text, signer }, colour = true) {
  const s = w / 800, pad = 36 * s;
  const muted = colour ? "#64748B" : "#000", accent = colour ? "#1E5FEB" : "#000";
  g.fillStyle = "#fff"; g.fillRect(0, 0, w, h);
  g.textBaseline = "alphabetic";

  g.fillStyle = muted; g.font = `700 ${Math.max(11, 18 * s)}px Arial, sans-serif`;
  g.fillText((heading || "").toUpperCase(), pad, pad + 14 * s);
  if (amount) {
    g.textAlign = "right";
    g.fillStyle = muted; g.font = `700 ${Math.max(10, 16 * s)}px Arial, sans-serif`;
    g.fillText((amountLabel || "").toUpperCase(), w - pad, pad + 14 * s);
    g.fillStyle = accent; g.font = `800 ${Math.max(20, 44 * s)}px Arial, sans-serif`;
    g.fillText(amount, w - pad, pad + 62 * s);
    g.textAlign = "left";
  }

  g.fillStyle = colour ? "#0F172A" : "#000";
  const fs = Math.max(11, 19 * s);
  g.font = `${colour ? 400 : 700} ${fs}px Arial, sans-serif`;
  const lines = wrap(g, text || "", w - pad * 2).slice(0, 4);
  lines.forEach((ln, i) => g.fillText(ln, pad, pad + (amount ? 104 : 58) * s + i * fs * 1.35));

  const ly = h * SIGN_LINE_Y;
  g.strokeStyle = colour ? "#94A3B8" : "#000"; g.lineWidth = Math.max(1, 2 * s);
  g.beginPath(); g.moveTo(pad, ly); g.lineTo(w - pad, ly); g.stroke();
  g.fillStyle = muted; g.font = `700 ${Math.max(11, 22 * s)}px Arial, sans-serif`;
  g.fillText("✕", pad, ly - 10 * s);
  g.font = `${Math.max(10, 15 * s)}px Arial, sans-serif`;
  g.fillText(signer ? `Sign here · ${signer}` : "Sign here", pad, ly + 26 * s);
}
